import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import { getEntityWebsiteReportEbook } from '../../utils';

const LaunchSuccessfulDialog = ({ open, handleClose }) => {
	const entity = getEntityWebsiteReportEbook();

	return (
		<GenericDialog
			open={open}
			handleClose={handleClose}
			confirmAction={handleClose}
			content={
				<Typography variant="body1">
					{_e('congratulations_launched', { entity })}
				</Typography>
			}
			title={_e('launch_successful')}
		/>
	);
};

LaunchSuccessfulDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
};

export default LaunchSuccessfulDialog;
